import { computed, ref, watch } from 'vue'

import { queryClient } from '#app/services/query'

export type Environment = 'acceptance' | 'production'

const STORAGE_KEY = 'admin.environment'

export const isAcceptanceDeploy = import.meta.env.MODE !== 'production'

function loadInitial(): Environment {
  const fallback: Environment = isAcceptanceDeploy ? 'acceptance' : 'production'
  if (typeof localStorage === 'undefined') return fallback
  const stored = localStorage.getItem(STORAGE_KEY)
  if (stored === 'acceptance' || stored === 'production') return stored
  return fallback
}

const environment = ref<Environment>(loadInitial())

watch(environment, (value) => {
  if (typeof localStorage !== 'undefined') {
    localStorage.setItem(STORAGE_KEY, value)
  }
  queryClient.invalidateQueries()
})

export function resolveBackendEnvironment(): Environment {
  return isAcceptanceDeploy ? 'acceptance' : environment.value
}

export function useEnvironment() {
  const isAcceptance = computed(() => environment.value === 'acceptance')
  const isProduction = computed(() => environment.value === 'production')

  function setEnvironment(value: Environment) {
    environment.value = value
  }

  return {
    environment,
    isAcceptance,
    isProduction,
    isAcceptanceDeploy,
    setEnvironment,
  }
}
